import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserInfo } from '../../../user-info';
import { UserService } from '../../user.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  standalone: false
})
export class EditProfileComponent implements OnInit {
  private userService = inject(UserService);

  editProfileForm = new FormGroup({
    name: new FormControl('', Validators.required)
  });

  nameError?: string;
  isLoading = false;
  @Input() userInfo: UserInfo;
  successMessage = '';
  errorMessage = '';

  ngOnInit() {
    this.editProfileForm.setValue({ name: this.userInfo.name });
  }

  onSubmit() {
    this.errorMessage = '';
    this.successMessage = '';
    this.nameError = this.checkName();
    if (!this.nameError) {
      this.isLoading = true;
      this.userService.editProfile(this.name.value).subscribe({
        next: () => {
          this.isLoading = false;
          this.successMessage = 'การเปลี่ยนชื่อสำเร็จ';
          this.userService.updateCurrentUser();
        },
        error: (err) => {
          this.isLoading = false;
          this.errorMessage = err?.error?.message;
        }
      });
    }
  }

  private checkName(): string {
    if (this.name.errors) {
      return 'กรุณาระบุชื่อ';
    }
    if (this.name.value === this.userInfo.name) {
      return 'ชื่อที่ต้องการเปลี่ยนต้องแตกต่างจากชื่อเดิม';
    }
  }

  private get name() {
    return this.editProfileForm.get('name');
  }
}
